type CartOption = string | { key: string; status?: string; disabled?: boolean; [field: string]: unknown };

// A method is usable only when the reservation lists it and does not mark it disabled.
// Irrelevant methods are left out entirely so the buyer never sees them.
export const mergePaymentMethodOptions = (userOptions: string[], cartOptions: CartOption[], known: object) => {
  const cartOptionsV2 = cartOptions.map((option) => (typeof option === "string" ? { key: option } : option));
  const irrelevant = new Set(
    cartOptionsV2.filter((option) => option.status === "irrelevant").map((option) => option.key)
  );

  return userOptions
    .filter((method) => method in known && !irrelevant.has(method))
    .map((method) => {
      const option = cartOptionsV2.find((option) => option.key === method);
      if (!option) return { method, disabled: true };
      return { method, ...option, disabled: !!option.disabled || option.status === "disabled" };
    });
};
